class Cookies {

    getCookies(cname) {
        var name = cname + '=';
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return '';
    }

    setCookies(name, value) {
        var date = new Date();
        date.setTime(date.getTime() + (100 * 24 * 60 * 60 * 1000));
        var expires = date.toGMTString();
        document.cookie = name + '=' + value + '; expires=' + expires + '; SameSite=Strict; Secure; path=/';
    }

    getTenantId() {
        return this.getCookies('tenantId');
    }
    setTenantId(tenantId) {
        this.setCookies('tenantId', tenantId);
    }

    removeCookies(cookieName) {
        this.setCookies(cookieName, '');
    }

    clearAll() {
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            const eq = cookies[i].indexOf('=');
            const name = eq >= 0 ? cookies[i].substring(0, eq).trim() : cookies[i].trim();
            if (name) {
                document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
            }
        }
    }

    getJwtToken() {
        return this.getCookies('jwtToken');
    }

    setJwtToken(tokenValue) {
        this.setCookies('jwtToken', tokenValue);
    }

    getAgencyId() {
        return this.getCookies('agencyId');
    }

    setAgencyId(agencyId) {
        this.setCookies('agencyId', agencyId);
    }
}

export default new Cookies()
